import { Table, Tag } from "antd";
import { useMemo } from "react";
import { getFullName } from "../../../utils/shared";

const CustomersTable = ({ customers = [], loading }) => {
  const columns = useMemo(
    () => [
      {
        title: "Name",
        key: "name",
        render: (_, record) => getFullName(record),
      },
      {
        title: "Email",
        dataIndex: "email",
        key: "email",
      },
      {
        title: "Phone",
        key: "phone",
        render: (_, record) => `${record.phone_country_code} ${record.phone}`,
      },
      {
        title: "Conversations Count",
        dataIndex: "conversation_count",
        key: "conversation_count",
        render: (count) => <Tag color={"blue"}>{count || 0}</Tag>,
      },
    ],
    [],
  );

  return (
    <Table
      columns={columns}
      dataSource={customers}
      rowKey="id"
      loading={loading}
      pagination={{ pageSize: 10 }}
      scroll={{ x: "max-content" }}
    />
  );
};

export default CustomersTable;
